import { Button, Flex, Typography, message, Card, theme } from 'antd'
import { useState } from 'react'
import PriceDescription from './price-description'
import PriceDisplay from './price-display'
import RecommendationTag from './recommendation-tag'
import { subscribeAssistantPlan } from '@/services/assistant-plan'

const { Text, Title } = Typography

const PlanCard = ({ plan = {}, style }) => {
  const { token } = theme.useToken()
  const [loading, setLoading] = useState(false)
  const {
    id,
    name,
    description,
    price,
    period,
    price_description,
    features,
    recommended,
  } = plan

  const featuresList = features?.map((feature, index) => (
    <li
      key={`${feature.substring(0, 10)}-${index}`}
      className="text-base font-normal"
    >
      {feature}
    </li>
  ))

  const handleSubscribe = async () => {
    setLoading(true)
    const currentUrl = window.location.href

    await subscribeAssistantPlan(id, {
      successURL: currentUrl,
      cancelURL: currentUrl,
    })
      .then(({ data }) => {
        if (data?.URL) {
          window.location.href = data.URL
        } else {
          message.error('Erro ao gerar link de pagamento')
        }
      })
      .catch((error) => {
        message.error(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const cardStyle = {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderColor: recommended
      ? token.colorPrimary
      : token.colorBorderSecondary,
    ...style,
  }

  const bodyStyle = {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    padding: token.paddingLG,
  }

  return (
    <Card style={cardStyle} styles={{ body: bodyStyle }}>
      {recommended && <RecommendationTag />}

      <Flex vertical style={{ flex: 1 }}>
        <Title
          level={4}
          style={{
            fontFamily: 'Sora, sans-serif',
            fontSize: token.fontSizeHeading4,
            fontWeight: token.fontWeightStrong,
            margin: 0,
            marginBottom: token.marginXS,
          }}
        >
          {name}
        </Title>
        <Text
          style={{
            color: token.colorTextDescription,
            fontFamily: token.fontFamily,
            fontSize: token.fontSize,
            lineHeight: token.lineHeight,
            marginBottom: token.marginLG,
          }}
        >
          {description}
        </Text>

        <ul
          className="list-disc"
          style={{
            paddingLeft: token.paddingLG,
            margin: 0,
            marginBottom: token.marginLG,
            color: token.colorText,
          }}
        >
          {featuresList}
        </ul>
      </Flex>

      <Flex vertical gap={token.marginMD}>
        <Flex align="center" gap={token.marginMD}>
          <PriceDisplay price={price} period={period} />
          <PriceDescription description={price_description} />
        </Flex>
        <Button
          type="primary"
          size="large"
          onClick={handleSubscribe}
          loading={loading}
          style={{
            width: '100%',
            borderRadius: token.borderRadiusLG,
          }}
        >
          Assinar agora
        </Button>
      </Flex>
    </Card>
  )
}
export default PlanCard
